import './inbox_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.TwitterVideoAttachment extends Backbone.Model

  initialize: (media) =>
    @media = media

  url:=>
    @find_video_url_by_tipe()
   
  is_twitter_gif: =>
    false
  
  is_twitter_video:=>
    true
  
  find_video_url_by_tipe:=>
    videos_urls = []
    video_variants = @media.video_info.variants
    if @media.original_media_url
      return @media.original_media_url
    mp4_variants = _.filter(video_variants, (variant)=>
      variant.content_type == "video/mp4"
    )
    mp4_variants_sortered_by_quality = _.sortBy(mp4_variants, (mp4_variant) => (-1)*mp4_variant.bitrate) 
    mp4_variants_sortered_by_quality[0].url
